import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[appAutofocus]',
    standalone: false,
})
export class AutofocusDirective implements AfterViewInit {
    constructor(private el: ElementRef<HTMLElement>) {}

    ngAfterViewInit(): void {
        setTimeout(() => this.el.nativeElement.focus());
    }
}
